import React from "react";

export const NeonDivider = ({ className = "" }) => (
  <div
    className={`h-px w-full ${className}`}
    style={{
      background:
        "linear-gradient(90deg, rgba(57,255,20,0), rgba(57,255,20,0.35), rgba(160,32,240,0.35), rgba(160,32,240,0))",
    }}
  />
);
